import React from 'react';
import { Box, Button, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Trash, Send2, ExportCurve } from 'iconsax-react';

interface StaffBulkActionToolbarProps {
  selectedIds: string[];
  onDeactivateAll: (ids: string[]) => void;
  onResendInviteAll: (ids: string[]) => void;
  onExportCSV: () => void;
}

const StaffBulkActionToolbar: React.FC<StaffBulkActionToolbarProps> = ({
  selectedIds,
  onDeactivateAll,
  onResendInviteAll,
  onExportCSV,
}) => {
  const { t } = useTranslation();

  if (selectedIds.length === 0) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      px={2}
      py={1}
      mb={1}
      bgcolor="primary.lighter"
      borderRadius={1}
      flexWrap="wrap"
    >
      <Chip label={`${selectedIds.length} selected`} color="primary" size="small" />
      <Button
        size="small"
        variant="outlined"
        color="error"
        startIcon={<Trash size={16} />}
        onClick={() => onDeactivateAll(selectedIds)}
      >
        {t('staff.bulk_deactivate')}
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<Send2 size={16} />}
        onClick={() => onResendInviteAll(selectedIds)}
      >
        {t('staff.bulk_resend_invite')}
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ExportCurve size={16} />}
        onClick={onExportCSV}
      >
        {t('report.export_csv')}
      </Button>
    </Box>
  );
};

export default StaffBulkActionToolbar;
